module.exports = __webpack_public_path__ + "img/natural-solution-banner.5d8c394d.png";